import React from 'react';

const CartGuide = () => {
    return (
        <div className='hei-cart-guide'>
            <div className='hei-cart-guide-container'>
                <div className='row'>
                    <div className='col-12 hei-cart-guide-title'>
                        Having trouble? <a href='https://henrys.zendesk.com/hc/en-ca/requests/new'>Contact us!</a>
                    </div>
                    <div className='col-6'>
                        <a
                            href='#'
                            className='chat-link'
                            onClick={() => {
                                const iframe = document.getElementById('launcher') as HTMLIFrameElement;

                                try {
                                    iframe?.contentWindow?.document.querySelector('button')?.click();
                                } catch (err) {
                                    console.error(err);
                                }
                            }}
                        >
                            Live Chat
                        </a>
                    </div>
                    <div className='col-6'>
                        <a href='tel:+18449761699'>1 844-976-1699</a>
                    </div>
                </div>
            </div>
            <div className='hei-cart-guide-links'>
                <div className='row'>
                    <div className='col-6'>
                        <a href='/shipping-policy'>Shipping Policy</a>
                    </div>
                    <div className='col-6'>
                        <a href='/exchange-returns-policy'>Exchange & Return Policy</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { CartGuide };
